module.exports = __webpack_public_path__ + "static/media/5.f0329ee2.jpg";